import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-3 shadow-xl text-sm">
      <p className="font-semibold text-gray-700 dark:text-gray-300 mb-1">
        {label}
      </p>
      <p className="text-primary-500 font-medium">
        Users: {payload[0]?.value?.toLocaleString()}
      </p>
    </div>
  );
};

const UsersBarChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={280}>
    <BarChart
      data={data}
      margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
      barSize={18}
    >
      <CartesianGrid
        strokeDasharray="3 3"
        stroke="rgba(148,163,184,0.1)"
        vertical={false}
      />
      <XAxis
        dataKey="month"
        tick={{ fontSize: 12, fill: "#94a3b8" }}
        axisLine={false}
        tickLine={false}
      />
      <YAxis
        tick={{ fontSize: 12, fill: "#94a3b8" }}
        axisLine={false}
        tickLine={false}
      />
      <Tooltip
        content={<CustomTooltip />}
        cursor={{ fill: "rgba(99,102,241,0.05)", radius: 6 }}
      />
      <Bar dataKey="users" radius={[6, 6, 0, 0]}>
        {data.map((_, i) => (
          <Cell
            key={i}
            fill={i === data.length - 1 ? "#6366f1" : "rgba(99,102,241,0.35)"}
          />
        ))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);

export default UsersBarChart;
